export default __webpack_public_path__ + "locales/hy-AM/DeleteThirdPartyDialog.json?hash=7452c4a3ffd89b0b6b8ee53d2d15b868";